








import Component from 'vue-class-component';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorCreateForm from '@/context/sensor/component/form/SensorCreateForm.vue';
import WorkPeriodTemplateForm
  from '@/context/work_period/component/template-form/WorkPeriodTemplateForm.vue';
import AssignWorkPeriodForm
  from '@/context/work_period/component/assign-form/AssignWorkPeriodForm.vue';
import { AssignWorkPeriod } from '@/context/work_period/model/AssignWorkPeriod';

@Component({
  components: {
    AssignWorkPeriodForm,
    WorkPeriodTemplateForm,
    SensorCreateForm
  }
})
export default class AssignWorkPeriodContainer extends FormContainer<AssignWorkPeriod> {
  model: AssignWorkPeriod = new AssignWorkPeriod();

  async formApi(): Promise<AssignWorkPeriod> {
    return new Promise((resolve, reject) => {
      resolve(new AssignWorkPeriod());
    });
  }
}
